<div class="min-h-screen max-h-screen min-w-screen max-w-screen bg-white overflow-hidden">
    <div class="flex items-center justify-center flex-col h-[40vh] text-center text-white"
         [style.background]="'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')'">
        <img src="svg/logo-blanco.svg" class="w-[130px]" alt="Logo Fincomercio" />
        <label class="text-3xl font-bold">Asóciate a</label>
        <label class="text-[1.3rem] font-medium mb-4 uppercase">
            Cooperativa de ahorro y crédito fincomercio ltda.
        </label>
    </div>
    <div class="bg-white h-[60vh] flex flex-col w-screen mt-0">
        <div class="flex justify-between w-auto h-6 bg-white -mt-1">
            <label class="text-white font-medium text-[10px] px-2 rounded-b-2xl"
                   [style.background]="'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')'"
                   for="version">
                <b>V. {{ webVersion }}</b>
            </label>

            @if(consultor() !== null) {
                <label class="text-white font-medium text-[10px] px-2 rounded-b-2xl"
                       [style.background]="'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')'"
                       for="">
                    <b>Tu asesor:</b> {{ consultor()?.name }}
                </label>
            }
        </div>
        <div class="h-full w-screen flex flex-col text-justify p-4 text-base text-gray-900">
            @if (consultor() !== null) {
                <label class="text-base font-sans mb-2 text-justify" for="information">
                    Durante tu proceso de vinculación validaremos tu identidad.
                </label>
                <label class="text-base font-sans mb-2 text-justify" for="information">
                    Recibirás mensajes en tu celular, por esto debes tenerlo a mano, al igual que el documento de identificación.
                </label>
                <label class="text-base font-sans mb-2 text-justify" for="information">
                    Si estás listo para iniciar, presiona el botón "Iniciar" a continuación.
                </label>

                <div class="h-10 w-full flex items-center justify-center">
                    <button type="button" class="btn-primary" (click)="next()">
                        Iniciar
                    </button>
                </div>
            } @else {
                <label class="text-base font-sans mb-2 text-justify" for="information">
                    Por favor solicita a tu Asesor Comercial el link o su QR para poder
                    continuar con tu proceso de vinculación
                </label>
            }
        </div>
    </div>
</div>
